import { BulkActivateAction } from "./bulk-activate-action";
import { BulkCancelAction } from "./bulk-cancel-action";
import { BulkConfirmAction } from "./bulk-confirm-action";
import { BulkDeleteAction } from "./bulk-delete-action";
import { BulkDownloadReportAction } from "./bulk-download-report-action";
import { BulkDuplicateAction } from "./bulk-duplicate-action";
import { BulkSendRatingEmailAction } from "./bulk-send-rating-email-action";
import { BulkTerminateAction } from "./bulk-terminate-action";

export function deliveryTableHasBulkSelectionActions(statusRoute: string | undefined): boolean {
  switch (statusRoute) {
    case "requested":
    case "pending-customer-confirmation":
    case "confirmed-by-customer":
    case "rescheduled-by-admin":
    case "confirmed":
    case "set":
    case "waiting-for-driver":
    case "alert":
    case "ongoing":
    case "completed":
    case "cancelled":
      return true;
    default:
      return false;
  }
}

export function DeliveryTableBulkActions({ statusRoute }: { statusRoute: string | undefined }) {
  switch (statusRoute) {
    case "requested":
      return (
        <>
          <BulkConfirmAction />
          <BulkCancelAction />
          <BulkDeleteAction />
          <BulkDuplicateAction />
        </>
      );
    case "pending-customer-confirmation":
    case "confirmed-by-customer":
    case "rescheduled-by-admin":
      return <BulkConfirmAction />;
    case "confirmed":
    case "set":
    case "waiting-for-driver":
      return (
        <>
          <BulkTerminateAction />
          <BulkCancelAction />
          <BulkDeleteAction />
        </>
      );
    case "alert":
      return <BulkTerminateAction />;
    case "ongoing":
      return (
        <>
          <BulkTerminateAction />
          <BulkCancelAction />
        </>
      );
    case "completed":
      return (
        <>
          <BulkDownloadReportAction />
          <BulkSendRatingEmailAction />
        </>
      );
    case "cancelled":
      return (
        <>
          <BulkActivateAction />
          <BulkDeleteAction />
        </>
      );
    default:
      return null;
  }
}
